<!--
 * @Author: huangl
 * @Date: 2020-08-31 17:22:03
 * @LastEditors: huangl
 * @LastEditTime: 2020-09-02 14:08:41
 * @Description: file content
 * @FilePath: \officesystem\src\App.vue
-->
<template>
  <div id="app" class="body-container">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" :key="$route.fullPath"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
require('./static/css/animate.min.css');
require('./static/iconfont/iconfont.css');
export default {
  name: 'App',
  data() {
    return {
      modalLoading: true,
      isShowLoading: true //loading
    };
  },
  created() {
    // 顶层页面不监听
    if (self == top) {
      return;
    }
    window.addEventListener('message', e => {
      if (e.data.refreshPageUrl) {
        if (e.data.refreshPageUrl.includes(this.$route.path)) {
          this.$router.replace('/empty');
        }
        window.setTimeout(() => {
          this.$router.push(e.data.refreshPageUrl);
        }, 100);
      }
      if (e.data.toggleNews) {
        this.$router.push('/home/chatMange');
      }
      if (e.data.clearWebTags) {
        this.$store.commit('clearWebTags', e.data.clearWebTags);
      }
    });
  }
};
</script>
<style lang="scss">
@import '~@/sass/base/_reset.scss';
@import '~@/sass/helper/_classes.scss';
@import '~@/sass/helper/_spacing.scss';
@import '~@/sass/helper/_common.scss';
#app {
  width: 100%;
  // min-width: 998px;
  height: 100%;
  margin: 0 auto;
  &::-webkit-scrollbar {
    width: 0;
  }
  .ivu-menu-submenu-title span > i,
  .ivu-menu-submenu-title > i {
    margin-right: 0;
  }
}
.fold-enter-active,
.fold-leave-active {
  transition: all ease-in-out 0.5s;
}
.fold-enter,
.fold-leave-active {
  opacity: 0;
}
.loadingBox {
  position: relative;
  display: block;
  border-radius: 50%;
  background-color: #2d8cf0;
  width: 30px;
  height: 30px;
  animation: myBounce 1s 0s ease-in-out infinite;
}
.loadingParentBox {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.toggleBtns {
  color: #2d8cf0;
  margin-left: 10px;
  &:hover {
    cursor: pointer;
  }
}

@keyframes myBounce {
  0% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 0;
  }
}
</style>
